import type { TemplateCard } from "../../../api/generated/model";

/** A template's still: a video's poster, an image's cover, never its video (decision 12). */
export function coverOf(template: TemplateCard): string | null {
  return (template.media === "video" ? template.cover_poster_url : template.cover_url) ?? null;
}
